import { render, staticRenderFns } from "./ToJPG.vue?vue&type=template&id=7c712076"
import script from "./ToJPG.vue?vue&type=script&lang=js"
export * from "./ToJPG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports